<template>
  <div>
    <c-q-separator class="q-pb-lg" :withBackButton="true" />

    <PageCaption
      pageCaptionTitle="Visualizar"
      pageCaptionDescription="Revise as Telas Institucionais e realize a Aprovação"
    />

    <InstitutionalIdentificationSectionView
      v-if="institutionalViewData"
      :institutionalData="institutionalViewData"
      :showDownloadButtons="true"
    />

    <InstitutionalAccordion
      v-if="institutionalViewData"
      :accordionsData="institutionalViewData.accordions"
      mode="view"
    />

    <c-q-separator class="q-pb-md" />

    <div class="row fit no-wrap items-top">
      <div class="q-pr-xl q-mr-xl">
        <InstitutionalRequestedAdjustmentsSection
          v-if="showSectionViewAskAdjustment"
        />
      </div>
    </div>


  <InstitutionalActionButtonsSection
                                              
    :propShowBtnCancelFocusedInstitutional="true"
    :propShowBtnEditFocusedInstitutional="true"
    :propShowBtnDiscardChanges="true"
    :propShowBtnRequestAdjustmentsToFocusedInstitutional="true"
    :propShowBtnSendFocusedInstitutionalToApprove="true"
    :propShowBtnResendFocusedInstitutionalToApprove="true"
    :propShowBtnApproveFocusedInstitutional="true"
    :propShowBtnPublishFocusedInstitutional="true"
    :propShowBtnViewCampaignDistribution="true"
  />


    <ModalRequestAdjustmentsInstitucional />

  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import PageCaption from '@/components/PageCaption.vue';
import InstitutionalAccordion from '@/components/telasInstitucionais/institutionalFormats/InstitutionalAccordion.vue';
import InstitutionalActionButtonsSection from '@/components/telasInstitucionais/institutionalFormats/InstitutionalActionButtonsSection.vue';
import InstitutionalIdentificationSectionView from '@/components/telasInstitucionais/institutionalFormats/InstitutionalIdentificationSectionView.vue';
import InstitutionalRequestedAdjustmentsSection from '@/components/telasInstitucionais/InstitutionalRequestedAdjustmentsSection.vue';
import ModalRequestAdjustmentsInstitucional from '@/views/modals/ModalRequestAdjustmentsInstitucional.vue';
import { useInstitutionalStore } from '@/stores/institutionalStore';
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional';

const route = useRoute();
const router = useRouter();
const institutionalStore = useInstitutionalStore();

const institutionalId = computed(() => Number(route.params.id));


const showSectionViewAskAdjustment = computed(() => {
  return institutionalStore.institutionalDetail?.comentarioAjuste
})


const mapTempo = (posicao: number, imagens: any[]) => {
  const img = imagens?.find(i => i.posicaoImagem === posicao);
  return img?.duracaoImagem || 0;
};

const institutionalViewData = computed(() => {
  const detail = institutionalStore.institutionalDetail;
  if (!detail) return null;

  const imagens = detail.imagens || [];

  const redesSubredesCsv = (detail.redes || [])
    .map((r: any) => `Rede ${r.codRede} - Subrede ${r.codSubrede}`)
    .join(', ');

  // ✅ pcsPorGrupo vem do backend: { D0: [...], D1: [...], D2: [...], D3: [...] }
  const pcsPorGrupo: Record<string, any[]> = detail.pcsPorGrupo || {}

  // ✅ Lista flat de todos os PCs (para CSV/download)
  const todosOsPcs = Object.values(pcsPorGrupo).flat()

  // ✅ CSV para exibição
  const pcsCsv = todosOsPcs.length > 0
    ? todosOsPcs.map((pc: any) => pc.codpontocaptura).join(', ')
    : (detail.pcsIds || []).join(', ') // fallback

  // ✅ Verifica se tem agrupamento real
  const temGrupos = Object.keys(pcsPorGrupo).length > 1

  const telasCadastradas = Array.isArray(detail.telasCadastradas)
  ? detail.telasCadastradas
  : (detail.telasCadastradas || '').split(',')

  const temImagem = (posicoes: number[]) =>
  imagens.some(img => posicoes.includes(img.posicaoImagem))

  return {
    ...detail,
    redesSubredesCsv,
    pcsCsv,
    pcsPorGrupo,
    todosOsPcs,
    temGrupos,

    accordions: {
      telasIniciais: [
        { id: 1, tela: 'Tela 1', posicao: 1, ordem: 1, tempo: mapTempo(1, imagens) },
        { id: 2, tela: 'Tela 2', posicao: 2, ordem: 2, tempo: mapTempo(2, imagens) },
        { id: 3, tela: 'Tela 3', posicao: 3, ordem: 3, tempo: mapTempo(3, imagens) },
        { id: 4, tela: 'Tela 4', posicao: 4, ordem: 4, tempo: mapTempo(4, imagens) }
      ],

      telasAtm: [
        { id: 8, botao: 'Botão 1', posicao: 8 },
        { id: 9, botao: 'Botão 2', posicao: 9 },
        { id: 10, botao: 'Botão 3', posicao: 10 },
        { id: 11, botao: 'Botão 4', posicao: 11 }
      ],

      telasAguardeGeral: [
        { id: 6, tela: 'Tela Geral', posicao: 6 }
      ],

      telasAguardeChip: [
        { id: 7, tela: 'Tela Chip', posicao: 7 }
      ],

      telasAbertura: [
        { id: 5, tela: 'Tela Abertura', posicao: 5 }
      ],

      imagens,

      corTexto: detail.corTexto ?? null,

      alterarTelaInicial: temImagem([1,2,3,4,8,9,10,11]) ? 'sim' : 'nao',
      alterarTelaAguarde: temImagem([6,7]) ? 'sim' : 'nao',

      alterarTelaAbertura: (
        temImagem([5]) || detail.exibeTelaAbertura
      ) ? 'sim' : 'nao',

      exibeTelaAbertura: detail.exibeTelaAbertura,

    }

  }

});


onMounted(async () => {
  const from = sessionStorage.getItem('from');

  if (!from) {
    router.push({ name: 'home' });
  } else {
    sessionStorage.removeItem('from');
  }

  if (institutionalId.value) {
    await institutionalStore.fetchInstitutionalById(institutionalId.value);
  }
});

router.beforeEach((to, from, next) => {
  sessionStorage.setItem('from', 'true');
  next();
});

</script>

<style scoped></style>
